/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerbackground1Inputs */

const en_flyerbackground1 = /** @type {(inputs: Flyerbackground1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Background color`)
};

const de_flyerbackground1 = /** @type {(inputs: Flyerbackground1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintergrundfarbe`)
};

/**
* | output |
* | --- |
* | "Background color" |
*
* @param {Flyerbackground1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerbackground1 = /** @type {((inputs?: Flyerbackground1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerbackground1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerbackground1(inputs)
	return de_flyerbackground1(inputs)
});
export { flyerbackground1 as "flyerBackground" }